<template>
  <div class="justify-content-center text-left mt-5 dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="$router.push({ name: 'admin.templates.edit', params: { id:id } });"
                style="float:right">
        {{ $t('common.Edit') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="remove()"
                style="float:right">
        {{ $t('common.Remove') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row mt-5">
      <div class="col-lg-6">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="createdAt">{{ $t('common.CreatedAt') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              id="createdAt"
              class="myInput"
              :disabled="true"
              v-model="createdAtFormatted" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="createdBy">{{ $t('common.CreatedBy') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              id="createdBy"
              class="myInput"
              :disabled="true"
              v-model="createdBy" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="updatedAt">{{ $t('common.UpdatedAt') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              id="updatedAt"
              class="myInput"
              :disabled="true"
              v-model="updatedAtFormatted" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="createdBy">{{ $t('fields.updatedBy') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              id="updatedBy"
              class="myInput"
              :disabled="true"
              v-model="updatedBy" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="category">{{ $t('common.Category') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              id="category"
              class="myInput"
              :disabled="true"
              v-model="category" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="subcategory">{{ $t('common.Subcategory') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              id="subcategory"
              class="myInput"
              :disabled="true"
              v-model="subCategory" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="phenotype">{{ $t('common.Phenotype') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              id="phenotype"
              class="myInput"
              :disabled="true"
              v-model="phenotype" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.Gender') }}:</label>
          </div>
          <div class="col-lg-9">
            <GenderInput id="gender"
                         :editable="false"
                         v-model="gender.value" />
          </div>
        </div>
        <div class="row my-3 align-items-center">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.risk') }}:</label>
          </div>
          <div class="col-lg-9">
            <TemplateRiskInput id="risk"
                               :editable="false"
                               v-model="risk" />
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div>
          <h4 class="text-center mb-3">
            {{ $t('entities.Template.SingularCs') }}
          </h4>
          <div>
            <ckeditor v-model="template"
                      :editor="editor"
                      :disabled="true"
                      @ready="onReady"
                      :config="editorConfig" />
          </div>
        </div>
        <div class="row my-3">
        </div>
        <div>
          <h4 class="text-center mb-3">
            {{ $t('entities.Template.SingularEn') }}
          </h4>
          <div>
            <ckeditor v-model="templateEn"
                      :editor="editor"
                      :disabled="true"
                      @ready="onReady"
                      :config="editorConfig" />
          </div>
        </div>
      </div>
      <div class="col-12 mt-3">
        <h4 class="text-center mb-4">
          {{ $t('entities.GenotypeCombination.Singular') }}
        </h4>
        <div>
          <b-table
            ref="table"
            striped
            borderless
            outlined
            dark
            hover
            responsive
            :items="genotypeCombinations"
            :fields="tableFields" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import DecoupledEditor from '@ckeditor/ckeditor5-editor-decoupled/src/decouplededitor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import UploadAdapterPlugin from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import AutoformatPlugin from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import FontFamilyPlugin from '@ckeditor/ckeditor5-font/src/fontfamily';
import FontSizePlugin from '@ckeditor/ckeditor5-font/src/fontsize';
import FontColorPlugin from '@ckeditor/ckeditor5-font/src/fontcolor';
import FontBackgroundColorPlugin from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline';
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment';
import ListPlugin from '@ckeditor/ckeditor5-list/src/list';
import IndentPlugin from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlockPlugin from '@ckeditor/ckeditor5-indent/src/indentblock';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import BlockQuotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import EasyImagePlugin from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import ImagePlugin from '@ckeditor/ckeditor5-image/src/image';
import ImageCaptionPlugin from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStylePlugin from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbarPlugin from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUploadPlugin from '@ckeditor/ckeditor5-image/src/imageupload';
import TablePlugin from '@ckeditor/ckeditor5-table/src/table';
import TableToolbarPlugin from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import MediaEmbedPlugin from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import HorizontalLinePlugin from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
import GenderInput from '@components/input/GenderInput';
import TemplateRiskInput from '@components/input/TemplateRiskInput';

export default {
  name: 'TemplateViewDetail',
  components: {
    GenderInput, TemplateRiskInput
  },
  data() {
    return {
      ready: false,
      editor: DecoupledEditor,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          AutoformatPlugin,
          HeadingPlugin,
          FontFamilyPlugin,
          FontSizePlugin,
          FontColorPlugin,
          FontBackgroundColorPlugin,
          BoldPlugin,
          ItalicPlugin,
          UnderlinePlugin,
          StrikethroughPlugin,
          AlignmentPlugin,
          ListPlugin,
          IndentPlugin,
          IndentBlockPlugin,
          LinkPlugin,
          BlockQuotePlugin,
          ImagePlugin,
          ImageCaptionPlugin,
          ImageStylePlugin,
          ImageToolbarPlugin,
          EasyImagePlugin,
          ImageUploadPlugin,
          TablePlugin,
          TableToolbarPlugin,
          MediaEmbedPlugin,
          ParagraphPlugin,
          UploadAdapterPlugin,
          HorizontalLinePlugin
        ],
        toolbar: [
          'heading',
          '|',
          'fontFamily',
          'fontSize',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          '|',
          'numberedList',
          'bulletedList',
          '|',
          'outdent',
          'indent',
          '|',
          'link',
          'blockQuote',
          'imageUpload',
          'insertTable',
          'mediaEmbed',
          '|',
          'undo',
          'redo',
          '|',
          'horizontalLine'
        ],
        fontFamily: {
          supportAllValues: true
        },
        fontSize: {
          options: [
            'tiny',
            'small',
            'default',
            'big',
            'huge'
          ]
        },
        image: {
          toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative'
          ]
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        }
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapState('viewTemplate', ['template', 'templateEn', 'category', 'subCategory', 'createdAt', 'createdBy', 'numberOfCombinations', 'updatedAt', 'updatedBy', 'risk']),
    gender() {
      return this.getGender();
    },
    phenotype() {
      return this.getPhenotype();
    },
    genotypeCombinations() {
      return this.getGenotypeCombinations();
    },
    tableFields() {
      const fields = ['Name'];
      for (let i = 0; i < this.numberOfCombinations; i += 1) {
        fields.push(`${i + 1}`);
      }
      return fields;
    },
    createdAtFormatted() {
      return this.$moment(this.createdAt).format('DD.MM.YYYY HH:mm:ss');
    },
    updatedAtFormatted() {
      return this.$moment(this.updatedAt).format('DD.MM.YYYY HH:mm:ss');
    }
  },
  created() {
    this.fetchTemplate(this.id)
      .then(() => {
        this.ready = true;
      })
      .catch(() => {
        this.$router.replace({ name: 'admin.templates.view' });
      });
  },
  methods: {
    ...mapActions({ fetchTemplate: 'viewTemplate/fetchTemplate' }),
    ...mapGetters({ getPhenotype: 'viewTemplate/getPhenotype',
      getGender: 'viewTemplate/getGender',
      getGenotypeCombinations: 'viewTemplate/getGenotypeCombinations' }),
    async remove() {
      this.$bvModal.msgBoxConfirm(this.$t('ViewTemplate.RemoveMessage', { 1: this.id }), {
        title: this.$t('ViewTemplate.ModalTitle'),
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        okTitle: 'Remove',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true
      })
        .then(async (value) => {
          if (value) {
            await this.axios.delete('/admin/templates/delete', {
              params: {
                Id: this.id
              }
            }).then(async (res) => {
              if (res.status === 204) {
                this.$root.$bvToast.toast(this.$t('ViewTemplate.SuccessToast.Body'), {
                  title: this.$t('ViewTemplate.SuccessToast.Title'),
                  variant: 'success',
                  toaster: 'b-toaster-top-right'
                });
                this.$router.push({ name: 'admin.templates.view' });
              }
            });
          }
        })
        .catch(() => {
          this.$root.$bvToast.toast(this.$t('ViewTemplate.FailureToast.Body'), {
            title: this.$t('ViewTemplate.FailureToast.Title'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
        });
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
